import { PatientId, WithPatientId } from '@/modules/surgicalEvent';
import { doctorBffApi } from '@/modules';
import { PostopInfoService } from './postopInfo.service';
import { PostopInfo } from './postopInfo.model';
import { wrapError } from '../../../error';
import { ID } from '@ianesthesie-kit/services';

export const postopInfoApi = doctorBffApi.injectEndpoints({
  endpoints: (builder) => ({
    postopInfos: builder.query<PostopInfo[], PatientId>({
      queryFn: ({ patientId }) =>
        PostopInfoService.getInstance(patientId).fetch().catch(wrapError),
      providesTags: (result, error, { patientId }) => [
        { type: 'PostopInfo', id: patientId }
      ]
    }),

    postopInfoById: builder.query<
      PostopInfo,
      WithPatientId<{ postopInfoId?: ID }>
    >({
      queryFn: ({ patientId, postopInfoId }) =>
        PostopInfoService.getInstance(patientId)
          .fetchOne(postopInfoId ?? '')
          .catch(wrapError),
      providesTags: (result, error, { patientId, postopInfoId }) => [
        { type: 'PostopInfo', id: `${patientId}_${postopInfoId}` }
      ]
    }),

    patchPostopInfo: builder.mutation<
      PostopInfo,
      WithPatientId<Partial<PostopInfo>>
    >({
      queryFn: ({ patientId, ...postopInfo }) =>
        PostopInfoService.getInstance(patientId)
          .patch(postopInfo)
          .catch(wrapError),
      invalidatesTags: (result, error, { patientId, id }) => [
        { type: 'PostopInfo', id: patientId },
        { type: 'PostopInfo', id: `${patientId}_${id}` },
        'Dashboard'
      ]
    })
  }),
  overrideExisting: false
});

export const {
  usePostopInfosQuery,
  usePatchPostopInfoMutation,
  usePostopInfoByIdQuery
} = postopInfoApi;
